<!-- 课程中心 -->
<template>
    <div class="course-center">
        <!-- 专栏详情页 -->
        <div v-if="isShowCoursePage" class="courses-list">
            <div class="banner">
                <div class="header">
                    <div class="go-back" @click="isShowCoursePage = false">返回</div>
                    <div class="line"></div>
                    <div>专栏</div>
                </div>
                <special-column-card-big
                    :card-info="specialColumnInfo"
                    class="special-column-card"
                    @clickStudy="toCourses"
                />
            </div>
            <div class="content">
                <main-loading v-if="isLoading"/>
                <template v-else>
                    <div v-if="total < 4" class="course-list-big">
                        <course-card-big
                            v-for="item, index in courseList"
                            :key="index"
                            :card-info="item"
                            :column-id="columnId"
                            class="course-item-big"
                        />
                    </div>
                    <div v-else class="course-list">
                        <course-card
                            v-for="item, index in courseList"
                            :key="index"
                            :card-info="item"
                            :column-id="columnId"
                            class="course-item"
                        />
                    </div>
                    <veui-pagination
                        v-if="courseList && courseList.length"
                        class="pagination"
                        :page="coursePn"
                        :page-size="courseRn"
                        :total="total"
                        @redirect="pageChange"
                    />
                </template>
            </div>
        </div>
        <!-- 专栏列表页 -->
        <div v-else class="column-list">
            <div v-if="bannerList.length" class="banner">
                <h3 class="title">推荐课程</h3>
                <!-- 轮播 banber -->
                <veui-carousel
                    class="banner-box"
                    indicator-align="end"
                    effect="slide"
                    :wrap="bannerList.length > 1"
                    :autoplay="bannerList.length > 1"
                    :interval="2000"
                    :indicator="bannerList.length > 1 ? 'radio' : 'none'"
                    :datasource="bannerList"
                >
                    <div
                        slot="item"
                        slot-scope="{img, index, id}"
                        v-visually="{
                            serverId: 17030,
                            area: 'banner',
                            isNotRepeat: true,
                            ext: {
                                placeid: id
                            }
                        }"
                    >
                        <img :src="img" @click="handleBannerClick(index)"/>
                    </div>
                </veui-carousel>
            </div>
            <div class="content">
                <h3 class="title">系列专栏</h3>
                <veui-tabs
                    ui="l"
                    :active.sync="curTabId"
                    @change="tabChange"
                >
                    <veui-tab
                        v-for="item in tabList"
                        :key="item.name"
                        :label="item.name"
                        :name="item.id"
                    />
                </veui-tabs>
                <main-loading v-if="isLoading"/>
                <template v-else>
                    <div v-if="columnTotal < 3" class="special-column-list-big">
                        <special-column-card-big
                            v-for="item, index in list"
                            :key="index"
                            :card-info="item"
                            class="card-item"
                            @clickStudy="({id}) => toCourseList('big-card', id)"
                        />
                    </div>
                    <div v-else class="special-column-list">
                        <special-column-card
                            v-for="item, index in list"
                            :key="index"
                            :card-info="item"
                            @toCourseList="({id}) => toCourseList('card', id)"
                        />
                    </div>
                    <veui-pagination
                        v-if="list && list.length"
                        class="pagination"
                        :page="columnPn"
                        :page-size="columnRn"
                        :total="columnTotal"
                        @redirect="columPageChange"
                    />
                </template>
            </div>
        </div>
    </div>
</template>

<script>
import {Carousel, Tabs, Tab, Pagination} from 'veui';
import specialColumnCard from './components/special-column-card.vue';
import specialColumnCardBig from './components/special-column-card-big.vue';
import courseCard from './components/course-card.vue';
import courseCardBig from './components/course-card-big.vue';
import {pageChange} from '@/utils/util';
import MainLoading from '../../components/law/main-loading.vue';

export default {
    name: 'course-center',
    data() {
        return {
            bannerList: [],
            curTabId: '0',
            tabList: [],
            list: [],
            courseList: [],
            // 是否展示 course
            isShowCoursePage: false,
            specialColumnInfo: {},
            coursePn: 1,
            courseRn: 12,
            total: 0,
            // 栏目 id
            columnId: '',
            columnPn: 1,
            columnRn: 8,
            // 专栏总数
            columnTotal: 0,
            isLoading: true
        };
    },
    components: {
        'veui-carousel': Carousel,
        'veui-tabs': Tabs,
        'veui-tab': Tab,
        specialColumnCard,
        specialColumnCardBig,
        courseCard,
        courseCardBig,
        'veui-pagination': Pagination,
        MainLoading
    },
    watch: {
        isShowCoursePage: {
            handler(val) {
                if (val) {
                    this.$wywLog.send({
                        serverId: 17030,
                        action: 'show',
                        area: 'zl-pv'
                    });
                    this.coursePn = 1;
                    this.getCourses();
                }
            },
            immediate: true
        }
    },
    mounted() {
        this.getColumnList();
        this.getBanner();
    },
    methods: {
        tabChange(data) {
            let {name: id} = data || {};
            this.$wywLog.send({
                serverId: 17030,
                action: 'click',
                area: 'btn-zlfl',
                typeID: id
            });
            this.curTabId = id;
            this.columnPn = 1;
            // 请求接口
            this.getColumnList();
        },

        /**
         * 去学习，展示专栏详情页
         * @param {String} type 触发点位
         * @param {number} id  专栏 id
         */

        toCourseList(type, id) {
            this.$wywLog.send({
                serverId: 17030,
                area: type === 'big-card' ? 'card-zl-go' : 'card-zl',
                action: 'click',
                scID: id
            });
            this.columnId = id;
            this.isShowCoursePage = true;
        },

        /**
         * 跳转课程落地页
         * @param {number} url 指定跳转的课程链接
         */

        toCourses({url}) {
            this.$wywLog.send({
                serverId: 17030,
                area: 'btn-zl-go',
                action: 'click'
            });
            // 无 url 则跳转专栏的第一个课程
            let coursesUrl = url || this.courseList?.[0]?.url;
            coursesUrl && window.open(coursesUrl);
        },

        /**
         * 课程翻页时更新数据
         *
         * @param {number} pn 第几页
         */

        pageChange(pn) {
            this.coursePn = pn;
            this.getCourses();
        },

        /**
         * 专栏翻页时更新数据
         *
         * @param {number} pn 第几页
         */

        columPageChange(pn) {
            this.columnPn = pn;
            this.getColumnList();
        },

        /**
         * 获取课程
         */

        getCourses() {
            this.isLoading = true;
            let {coursePn: pn, courseRn: rn, columnId: column_id} = this;
            this.$http
                .get('/bp/course/getitem', {
                    params: {
                        column_id,
                        pn,
                        rn
                    }
                })
                .then(res => {
                    this.isLoading = false;
                    const data = this.$normalizeResponseData(res);
                    if (!data) {
                        return;
                    }
                    this.specialColumnInfo = data.column || {};
                    this.courseList = data.item_list || [];
                    this.total = data.item_cnt || 0;
                })
                .catch(err => {
                    this.isLoading = false;
                    this.$normalizeResponseError(err);
                });
        },

        // 获取 banner
        getBanner() {
            this.$http
                .get('/bp/course/getbanner')
                .then(res => {
                    const data = this.$normalizeResponseData(res);
                    if (!data) {
                        return;
                    }
                    this.bannerList = data.banner_list || [];
                })
                .catch(err => {
                    this.$normalizeResponseError(err);
                });
        },

        /**
         * 点击 banner
         * @param {Number} index 点击的是第几个 banner,从0开始
         */

        handleBannerClick(index) {
            let data = this.bannerList[index] || {};
            this.$wywLog.send({
                serverId: 17030,
                area: 'banner',
                action: 'click'
            });
            if (!data.url) {
                return;
            }
            pageChange({
                type: 'newtab',
                url: data.url
            });
        },

        /**
         * 获取分类菜单及专栏列表
         */

        getColumnList() {
            this.isLoading = true;
            let {columnPn: pn, columnRn: rn} = this;
            this.$http
                .get('/bp/course/getcolumn', {
                    params: {
                        domain_id: this.curTabId || 0,
                        pn,
                        rn
                    }
                })
                .then(res => {
                    this.isLoading = false;
                    const data = this.$normalizeResponseData(res);
                    if (!data) {
                        return;
                    }
                    this.list = data.column_list || [];
                    this.columnTotal = data.column_cnt || 0;
                    this.tabList = data.domain_list?.map(item => {
                        item.id += '';
                        return item;
                    }) || [];
                }).catch(err => {
                    this.isLoading = false;
                    this.$normalizeResponseError(err);
                });
        }
    }
};
</script>

<style lang='less' scoped>
.course-center {
    .column-list,
    .courses-list {
        height: 100%;
        width: 100%;
        display: flex;
        flex-direction: column;
    }

    .courses-list {
        .banner {
            height: 345px;

            .special-column-card {
                margin-top: 24px;
            }
        }

        .header {
            display: flex;
            font-family: PingFangSC-Regular;
            font-size: 16px;
            color: #333;
            line-height: 16px;
            font-weight: 400;

            .go-back {
                position: relative;
                padding-left: 17px;
                cursor: pointer;

                &::before {
                    content: "";
                    position: absolute;
                    height: 12px;
                    width: 10px;
                    left: 0;
                    top: 50%;
                    transform: translateY(-50%);
                    background: url(https://lvlin-base.cdn.bcebos.com/bend/back-icon.png) no-repeat center center / 100% 100%;
                }
            }
        }

        .line {
            margin: auto 12px;
            height: 12px;
            width: 2px;
            background-color: rgba(153, 153, 153, 1);
        }

        .course-list {
            display: grid;
            grid-template-columns: repeat(4, 252px);
            grid-gap: 24px 24px;
        }

        .course-item-big:not(:first-child) {
            margin-top: 24px;
        }
    }

    .title {
        line-height: 1;
    }

    .special-column-list-big {
        .card-item {
            margin-top: 24px;
        }
    }

    .special-column-list {
        margin-top: 24px;
        display: grid;
        grid-template-columns: repeat(4, 252px);
        grid-gap: 24px 24px;
    }

    .banner {
        height: 254px;
        background: #fff;
        width: 100%;
        padding: 30px 24px 24px;
        border-radius: 8px;
        box-sizing: border-box;
        margin-bottom: 24px;
        box-shadow: 0px 6px 14px 0px rgba(227,233,237,0.35);

        .banner-box {
            height: 160px;
            width: 100%;
            border-radius: 8px;
            margin-top: 24px;
            cursor: pointer;

            /deep/img {
                width: 100%;
                height: 100%;
                object-fit: cover;
            }

            /deep/.veui-carousel-item {
                border-radius: 8px;
            }

            /deep/ .veui-sr-only {
                display: none;
            }

            /deep/ .veui-carousel-control {
                display: none;
            }
        }
    }

    .content {
        background: #FFFFFF;
        box-shadow: 0px 6px 14px 0px rgba(227,233,237,0.35);
        border-radius: 8px;
        padding: 30px 24px 24px;
        display: flex;
        flex-direction: column;

        /deep/.veui-tabs {
            .veui-tabs-item-label {
                font-size: 14px;
            }

            .veui-tabs-item:not(.veui-tabs-item-active) > .veui-tabs-item-label {
                color: #333;
                font-family: PingFangSC-Regular;
            }
        }

        /deep/.main-loading {
            min-height: 265px;
        }
    }

    .pagination {
        width: 100%;
        margin-top: 24px;
        justify-content: flex-end;
    }
}
</style>
